(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-accordion"] && !Shopify.designMode) return;
  try {
    
(function(){
  var input = document.querySelector('[data-faq-search]');
  if (!input) return;
  input.addEventListener('input', function () {
    var term = input.value.trim().toLowerCase();
    var items = document.querySelectorAll('[data-faq-item]');
    var visibleCount = 0;
    items.forEach(function (item) {
      var match = item.getAttribute('data-question').toLowerCase().indexOf(term) > -1;
      item.hidden = term.length > 0 && !match;
      if (!item.hidden) visibleCount++;
    });
    var empty = document.querySelector('[data-faq-empty]');
    if (empty) empty.hidden = visibleCount > 0;
  });
})();

  } catch(e) { console.error(e); }
})();
})();
